import { render, staticRenderFns } from "./SatisfactionQuartersChart.vue?vue&type=template&id=a1ffcf18&scoped=true"
import script from "./SatisfactionQuartersChart.vue?vue&type=script&lang=js"
export * from "./SatisfactionQuartersChart.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionQuartersChart.vue?vue&type=style&index=0&id=a1ffcf18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ffcf18",
  null
  
)

export default component.exports